import { defineMessages } from '@atlassian/jira-intl';

// eslint-disable-next-line formatjs/no-multiple-plurals
export default defineMessages({
	headerNew: {
		id: 'project-directories.components.delete.header-new',
		defaultMessage: 'Delete {component} component',
		description:
			'Title of a modal dialog that asks user for confirmation before deleting a Project Component',
	},
	deleteButton: {
		id: 'project-directories.components.delete.delete-button',
		defaultMessage: 'Delete',
		description: '',
	},
	cancelButton: {
		id: 'project-directories.components.delete.cancel-button',
		defaultMessage: 'Cancel',
		description: '',
	},
	deleteComponentCount: {
		id: 'project-directories.components.delete.delete-component-count',
		defaultMessage: '{count} {count, plural, one {issue} other {issues}}',
		description: '',
	},
	deleteComponentRestMessage: {
		id: 'project-directories.components.delete.delete-component-rest-message',
		defaultMessage:
			' use this component. You can change {count, plural, one {its} other {their}} component to another in this project or remove the component from {count, plural, one {this issue} other {these issues}}.',
		description: '',
	},
	deleteComponentWarningLink: {
		id: 'project-directories.components.delete.delete-component-warning-link',
		defaultMessage:
			'{relatedIssueCount, plural, one {There is 1 issue} other {There are {relatedIssueCount} issues}} using this component.',
		description:
			'This message shows when users are trying to delete a Project Component but the component is assigned to some issues. Users need to decide what to do with these issues before they can proceed with deleting. "Issues" in this context means "Jira tickets". {relatedIssueCount} is a variable that will contain a number of affected issues. This sentence will be a link that points to the list of all affected issues.',
	},
	deleteComponentWillAffectIssues: {
		id: 'project-directories.components.delete.delete-component-will-affect-issues',
		defaultMessage:
			'Deleting this component will affect {relatedIssueCount, plural, one {this issue} other {these issues}}.',
		description:
			'This message shows when users are trying to delete a Project Component but the component is assigned to some issues. Users need to decide what to do with these issues before they can proceed with deleting. "Issues" in this context means "Jira tickets". {relatedIssueCount} is a variable that will contain a number of affected issues.',
	},
	deleteComponentYouCanChangeIssues: {
		id: 'project-directories.components.delete.delete-component-you-can-change-issues',
		defaultMessage:
			'You can change the component or remove the component {relatedIssueCount, plural, one {from this issue} other {from these issues}}.',
		description:
			'This message shows when users are trying to delete a Project Component but the component is assigned to some issues. Users need to decide what to do with these issues before they can proceed with deleting. "Issues" in this context means "Jira tickets". {relatedIssueCount} is a variable that will contain a number of affected issues.',
	},
	changeComponentRadio: {
		id: 'project-directories.components.delete.change-component-radio',
		defaultMessage: 'Change current issues to component',
		description:
			'This message shows when users are trying to delete a Project Component but the component is assigned to some issues. This is a label of selectbox, to choose another component. Jira will then migrate all issues to use the new component instead of the deleted one. "Issues" in this context means "Jira tickets".',
	},
	removeComponentRadio: {
		id: 'project-directories.components.delete.remove-component-radio',
		defaultMessage: 'Remove component from all issues.',
		description: '',
	},
	componentPickerPlaceholder: {
		id: 'project-directories.components.delete.component-picker-placeholder',
		defaultMessage: 'Select component',
		description: '',
	},
});
